<template id="item">
<div>
    <vs-divider>
        {{label}}
    </vs-divider>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
        <vs-select v-validate="'required'" name="person" :label="$t('Person') |ToUppercase" class="w-full" v-model="person">
          <vs-select-item
            v-for="person in persons"
            :text='person.firstname + " " + person.lastname'
            :value="person.id"
            :key="person.id"
          />
        </vs-select>
        <!-- <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Person') |ToUppercase"
            type="text"
            v-model="item.person"
            name="person"
            /> -->
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.person`)"
            >{{ errors.first(`${vvFormScope}.person`) }}</span>
        </div>    
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Cash') |ToUppercase"
            type="number"
            v-model.number="item.cash"
            name="cash"
            @input="updateTotal"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.cash`)"
            >{{ errors.first(`${vvFormScope}.cash`) }}</span>
        </div>   
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Pos') |ToUppercase"
            type="number"
            v-model.number="item.pos"
            name="pos"
            @input="updateTotal"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.pos`)"
            >{{ errors.first(`${vvFormScope}.pos`) }}</span>
        </div>   
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Together') |ToUppercase"
            type="number"
            v-model.number="item.together"
            name="together"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.together`)"
            >{{ errors.first(`${vvFormScope}.together`) }}</span>
        </div>     
    </div>
    <div class="vx-row">
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Boni') |ToUppercase"
            type="number"
            v-model="item.boni"
            name="boni"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.boni`)"
            >{{ errors.first(`${vvFormScope}.boni`) }}</span>
        </div>    
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('NarodniDom') |ToUppercase"
            type="number"
            v-model="item.narodnidom"
            name="narodnidom"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.narodnidom`)"
            >{{ errors.first(`${vvFormScope}.narodnidom`) }}</span>
        </div>   
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Tasajko') |ToUppercase"
            type="number"
            v-model="item.tasajko"
            name="tasajko"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.tasajko`)"
            >{{ errors.first(`${vvFormScope}.tasajko`) }}</span>
        </div>   
        <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Other') |ToUppercase"
            type="number"
            v-model="item.other"
            name="other"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.other`)"
            >{{ errors.first(`${vvFormScope}.other`) }}</span>
        </div>     
    </div>
</div>
</template>
<script>
export default {
  inject: ["$validator"],
  name: "report-item-component",
  template: "#item",
  props: {
    item: {
      type: Object
    },
    vvFormScope: {
      type: String
    },
    label: {
        type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  methods: {
    updateTotal(){
      this.item.together = Number(this.item.cash) + Number(this.item.pos);
    },
  },
  computed: {
    persons(){
      console.log("Uporabniki vrnjeni");
      return this.$store.state.admin.users.slice();
    }
  },
  created() {
    this.$store.dispatch("admin/fetchUsers");
    console.log("Pridobivam uporabnike");
  }
};
</script>